import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

const translations: Record<string, I18nDefinition> = {
  addProductQuantityErrorTitle: {
    id: 'product_page_add_to_cart_add_product_quantity_error_title',
    defaultMessage: "Vous ne pouvez ajouter qu'un seul produit du même modèle",
  },
  addProductQuantityErrorDescription: {
    id: 'product_page_add_to_cart_add_product_quantity_error_description',
    defaultMessage:
      "Nous vous invitons à finaliser cette commande avant d'en ouvrir une nouvelle.",
  },
  addProductStockErrorTitle: {
    id: 'product_page_add_to_cart_add_product_stock_error_title',
    defaultMessage: 'This product is no longer available',
  },
  addProductStockErrorDescription: {
    id: 'product_page_add_to_cart_add_product_stock_error_description',
    defaultMessage: 'Please refresh the page and try again.',
  },
  alreadyOneMobilePlanErrorTitle: {
    id: 'product_page_add_to_cart_already_one_mobile_plan_error_title',
    defaultMessage: "Vous ne pouvez souscrire qu'à un seul forfait à la fois.",
  },
  alreadyOneMobilePlanErrorDescription: {
    id: 'product_page_add_to_cart_already_one_mobile_plan_error_description',
    defaultMessage:
      "Nous vous invitons à finaliser cette commande avant d'en ouvrir une nouvelle.",
  },
  insufficientRemainingBalanceErrorTitle: {
    id: 'product_page_add_to_cart_listing_not_eligible_to_mobile_plan_error_title',
    defaultMessage:
      "The mobile plan isn't available with the selected device configuration.",
  },
  insufficientRemainingBalanceErrorDescription: {
    id: 'product_page_add_to_cart_listing_not_eligible_to_mobile_plan_error_description',
    defaultMessage:
      'Please remove the mobile plan or choose a different device configuration.',
  },
  mobilePlanIncompatibleWithPromoCodeTitle: {
    id: 'product_page_add_to_cart_mobile_plan_incompatible_with_promo_code_title',
    defaultMessage:
      "Heads up: mobile plans and flash sale discounts can't be combined.",
  },
  mobilePlanIncompatibleWithPromoCodeDescription: {
    id: 'product_page_add_to_cart_mobile_plan_incompatible_with_promo_code_description',
    defaultMessage:
      "The product wasn't added to your cart. To get the mobile plan, please remove the flash sale discount from your cart or place a separate order.",
  },
  promoCodeIncompatibleWithMobilePlanTitle: {
    id: 'product_page_add_to_cart_promo_code_incompatible_with_mobile_plan_title',
    defaultMessage:
      "Heads up: mobile plans and flash sale discounts can't be combined.",
  },
  promoCodeIncompatibleWithMobilePlanDescription: {
    id: 'product_page_add_to_cart_promo_code_incompatible_with_mobile_plan_description',
    defaultMessage:
      "The product wasn't added to your cart. To get the flash sale discount, please remove the mobile plan from your cart or place a separate order.",
  },
}

export default translations
